import { render, staticRenderFns } from "./autoSuggest.vue?vue&type=template&id=2bc91320"
import script from "./autoSuggest.vue?vue&type=script&lang=js"
export * from "./autoSuggest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports